import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RegistrationForm from "./RegistrationForm"
import { registerUser } from "../../redux/actions/authActions"
import Spinner from "../common/Spinner";
import { toast } from "react-toastify";


function RegistrationPage({
    auth,
    registerUser,
    groupInvitation,
    history,
    ...props
}) {

    const urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    const [user, setUser] = useState({ ...props.user });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [registrationComplete, setRegistrationComplete] = useState(false);

    useEffect(() => {
        if (auth.isAuthenticated) {
            history.push("/");
        }
        document.title = "Sign up | JustGoRide";
    }, []);

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!user.firstName) {
            errors.firstName = "First Name is required.";
            setErrors(errors);
            isValid = false;
        }
        else if (user.firstName.length > 18) {
            errors.firstName = "Your first name cannot exceed 18 charactors.";
            setErrors(errors);
            isValid = false;
        }
        else if (urlRegex.test(user.firstName)) {
            errors.firstName = "You cannot enter a url in this field";
            setErrors(errors);
            isValid = false;
        }
        
        if (!user.surname) {
            errors.surname = "Surname is required.";
            setErrors(errors);
            isValid = false;
        }
        else if (user.surname.length > 18) {
            errors.surname = "Your surname cannot exceed 18 charactors.";
            setErrors(errors);
            isValid = false;
        }
        else if (urlRegex.test(user.surname)) {
            errors.surname = "You cannot enter a url in this field";
            setErrors(errors);
            isValid = false;
        }

        if (!user.username) {
            errors.username = "Username is required.";
            setErrors(errors);
            isValid = false;
        }
        else if (!emailRegex.test(user.username) && user.username.length > 20) {
            errors.username = "Your username cannot exceed 20 charactors.";
            setErrors(errors);
            isValid = false;
        }
        else if (urlRegex.test(user.username)) {
            errors.username = "You cannot enter a url in this field";
            setErrors(errors);
            isValid = false;
        }

        if (!user.email) {
            errors.email = "Email address is required.";
            setErrors(errors);
            isValid = false;
        } else if (!emailRegex.test(user.email)) {
            errors.email = "Email address format invalid.";
            setErrors(errors);
            isValid = false;
        }

        if (!user.password) {
            errors.password = "You must specify a password.";
            setErrors(errors);
            isValid = false;
        }

        if (!user.passwordConfirmation) {
            errors.passwordConfirmation = "You must confirm the password.";
            setErrors(errors);
            isValid = false;
        }

        if (user.password !== user.passwordConfirmation) {
            errors.passwordConfirmation = "The passwords must match.";
            setErrors(errors);
            isValid = false;
        }

        var passwordStrength = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        if (!passwordStrength.test(user.password)) {
            errors.password = "Password must be at least 8 characters in length, contain upper and lowercase letters and at least one number.";
            setErrors(errors);
            isValid = false;
        }

        if (!user.acceptTc) {
            errors.acceptTc = "Please accept the site terms and conditions";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    function handleChange(event) {
        if (event.target.name === "acceptTc") {
            const { name, checked } = event.target;
            setUser(prevUser => ({
                ...prevUser,
                [name]: checked
            }));
        } else {
            const { name, value } = event.target;
            setUser(prevUser => ({
                ...prevUser,
                [name]: value
            }));
        }
    }

    function handleRegistration(event) {
        event.preventDefault();

        if (!formIsValid()) return;

        setProcessing(true);

        if (groupInvitation.code) {
            user.groupInvitation = groupInvitation;
        }

        registerUser(user).then((result) => {
            toast.success("Registration Complete");
            setProcessing(false);
            setRegistrationComplete(true);
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onRegistration: error.message });
        });

    }

    return (
        <div className="jgr-registration">
            {registrationComplete ?
           
                <div>
                    <h2 className="text-center">Registration Complete - Email Confirmation Sent</h2>
                    <p className="text-center">
                        We have sent you an email to confirm you account.
                    </p>
                    <p className="text-center">
                        Please click on the link in the email to activate your user profile.
                    </p>
                    <p className="text-center">
                        If you haven't received the activation email, please check your Spam folder.
                    </p>
                </div>
            : 
            processing ?
                <Spinner /> :
                (
                    <RegistrationForm
                        user={user}
                        errors={errors}
                        onChange={handleChange}
                        onRegister={handleRegistration}
                        processing={processing}
                    />
                )
            }
        </div>
    );

}

RegistrationPage.propTypes =
    {
        user: PropTypes.object.isRequired,
        registerUser: PropTypes.func.isRequired,
        auth: PropTypes.object.isRequired,
        groupInvitation: PropTypes.object.isRequired
    }


function mapStateToProps(state) {
    return {
        user: { firstName: "", surname: "", username: "",  email: "", password: "", passwordConfirmation: "", acceptTc: false },
        auth: state.auth,
        groupInvitation: state.groupInvitation
    };
}

const mapDispatchToProps = {
    registerUser
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage); 


// WEBPACK FOOTER //
// ./src/components/user/RegistrationPage.js